import React from "react";
import { CreatorInterests } from "../../../../Task/tabs/ProfileDataTab/single/CreatorInterests";

export const renderCreatorInterests = (
  label,
  data,
  layout,
  GridBoxComponent,
) => {
  let boxData = null;

  if (data?.user_audience_data?.influencersInterests) {
    boxData = data?.user_audience_data?.influencersInterests;
  }

  if (data?.creatorsInterests) {
    boxData = data?.creatorsInterests;
  }

  const height = layout?.find((item) => item.i === label)?.h;

  return (
    <GridBoxComponent key={label} id={label}>
      <CreatorInterests data={boxData} height={height} />
    </GridBoxComponent>
  );
};
